

//工单类型
export const orderTypeOption = [
  { label: "安装", value: "1" },
  { label: "维修", value: "2" },
  { label: "清洗", value: "3" },
  { label: "拆移机", value: "4" },
  { label: "咨询", value: "5" },
  { label: "投诉", value: "6" },
  { label: "销售线索", value: "7" },
  { label: "空调租赁", value: "8" },
  { label: "退换货", value: "9" },
  { label: "回访", value: "10" },
  { label: "回收", value: "11" },
  { label: "以旧换新", value: "12" }
];
//合作方合作种类

export const partnerTypeList = [
  { label: "以旧换新-支线物流", value: "1" },
  { label: "批量回收", value: "2" }
];

//归集仓状态
export const warehouseStatus = [
  { label: "启用", value: 0 },
  { label: "停用", value: 1 }
];

//线上/线下渠道
export const salePlatformType = [
  { label: "线上渠道", value: 1 },
  { label: "线下渠道", value: 2 }
];

/*
 * 商用旧机查询相关 start
 */

//商用C 旧机OM类型>旧机系列 todo 具体的值待定
export const COMType = [
  {
    label: "家装中央空调", value: 1,
    children: [
      { label: "家装多联机", value: 101 },
      { label: "风管机", value: 102 },
      { label: "天井机", value: 103 },

    ]
  },
  {
    label: "工装中央空调", value: 2, children: [
      { label: "商用多联", value: 201 },
      { label: "单元机", value: 202 },
      { label: "热风机", value: 203 },
      { label: "户式机", value: 204 },
      { label: "成套风冷冷凝机组", value: 205 },
      { label: "卧式暗装风机盘管", value: 206 },
      { label: "商用热水机", value: 207 },
      { label: "风冷模块机", value: 208 },
      { label: "离心式冷水机组", value: 209 },
      { label: "螺杆式冷水机组", value: 210 }
    ]
  }
];
//结算状态 todo 具体的值待定
export const settlementStatusOption = [
  { label: "不可结算", value: 0 },
  { label: "可结算", value: 1 },
  { label: "已结算", value: 2 }
];

//旧机状态 todo 具体取值待定
export const oldMachineOption = [
  { label: "待报价", value: 10000 },
  { label: "已报价", value: 10100 },
  { label: "待派车", value: 10101 },
  { label: "待预约", value: 10102 },
  { label: "待上门", value: 10103 },
  { label: "回收中", value: 10110 },
  { label: "物流已验收", value: 10201 },
  { label: "再生资源已入库", value: 10400 }
];

//订单状态 todo 具体取值待定
export const orderStatusOption = [
  { label: "待派车", value: '1' },
  { label: "待预约", value: '2' },
  { label: "待上门", value: '3' },
  { label: "回收中", value: '4' },
  { label: "已完成", value: '7' },
  { label: "已取消", value: '8' }
];




// WEBPACK FOOTER //
// ./src/views/COldForNewService/mixin.js